import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import './TopNavigation.css'
import Button from 'pobble-components/dist/button'
import { withMe } from 'pobble-components/dist/pobble-user'
import { browserHistory, Link } from 'react-router-dom'


@autobind
class TopNavigation extends Component {

  render () {
    const userSchoolId = this.props.me && this.props.me.account && this.props.me.account.teacher_type && this.props.me.account.teacher_type.school && this.props.me.account.teacher_type.school.id
    const studentSchoolId = this.props.me && this.props.me.account && this.props.me.account.student_type && this.props.me.account.student_type.school && this.props.me.account.student_type.school.id

    return (
      <nav styleName='container'>
        <div styleName='inner'>
          <Link to="/" styleName={this.props.selected && this.props.selected === 'global' && 'selected' || ''}>Newly published</Link>
          {(userSchoolId || studentSchoolId) && <Link to={`/schools/${userSchoolId || studentSchoolId}`} styleName={this.props.selected && this.props.selected === 'school' && 'selected' || ''}>Schools</Link>}
        </div>
        {userSchoolId && <Button primary tall href="/actions/upload" styleName='upload'>Upload writing</Button>}
      </nav>
    )
  }
}

export default withMe(TopNavigation)




// WEBPACK FOOTER //
// ./shared/TopNavigation.js